module.exports = __webpack_public_path__ + "img/V74.558097b5.jpg";